import React, { useState } from 'react';
import CheckBox from '../../../UI/CheckBox';
import QuestionnaireModal from './QuestionnaireModal';
import { questionnaire } from '../../../../Constants/Questions';
import Button from '../../../UI/Button';

const QuestionnaireCheckboxWrapper = ({ reff, nextOnClick, onCheckBoxChange, dispError, onModalClick, display, questArr,questName }) => {
    const [showQest7Sub1, setShowQest7Sub1] = useState(false);
    const [showQest7Sub2, setShowQest7Sub2] = useState(false);
    const [gtmData, setGtmData] = useState({
        value: '',
      });
    const onAnscheckSub1 = (e) => {
        let subQustArr = ['27', '32'];
        if (subQustArr.includes(e.target.value)) {
            setShowQest7Sub1(false);
            setShowQest7Sub2(false);
            if (e.target.checked == true) {
                if (e.target.value === "27") {
                    setShowQest7Sub1(true);
                } else if (e.target.value === "32") {
                    setShowQest7Sub2(true);
                }
            }
        }
        
    }
    const questCheckBoxAnswers = questArr.answers.map((answer, index) => {
        return (
            <CheckBox
                key={`${index}`}
                className="custom-checkbox"
                labelClassName="br radioa"
                CheckBoxText={answer.label}
                value={answer.value}
                dataId={answer.value}
                onChange={onCheckBoxChange}
                onClick={(e) => onAnscheckSub1(e)}
            />
        )
    });

    
    return (
        <>
            <div className="radio-box question" ref={reff} >
                <h4>
                    {questArr.question}
                </h4>
                <div className="form-group">
                    <div className="cstfrm" id="question_group_66" >
                        {questCheckBoxAnswers}
                        {/* <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-1" value="26" dataId="26"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-2" value="27" dataId="27"
                            onChange={onCheckBoxChange}
                            onClick={onAnscheckSub1}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-3" value="28" dataId="28"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-4" value="29" dataId="29"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-5" value="30" dataId="30"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-6" value="31" dataId="31"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-7" value="32" dataId="32"
                            onClick={onAnscheckSub1}
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-8" value="33" dataId="33"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-9" value="34" dataId="34"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-10" value="35" dataId="35"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-11" value="36" dataId="36"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-12" value="37" dataId="37"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-13" value="38" dataId="38"
                            onChange={onCheckBoxChange}
                        />
                        <CheckBox
                            className="custom-checkbox" labelClassName="br radioa"
                            CheckBoxText="Option-14" value="39" dataId="39"
                            onChange={onCheckBoxChange}
                        /> */}
                        <Button
                            type="button"
                            className="btn-primary form-control"
                            onClick={nextOnClick}
                            buttonText="Next >"
                            gtmFire="true"
                            clickevent={questArr.clickevent}
                            gtm_question={questName}
                            gtm_answer=''
                            gtm_trigger={questArr.gtm_trigger}
                        />
                        <span className={`error_msg ${dispError}`}>Please select atleast one option</span>
                    </div>
                </div>
            </div>
            <QuestionnaireModal questArr={questionnaire.questinnare7Sub1} popDisplay={showQest7Sub1} onModalClick={onModalClick} questName='questinnare7Sub1' />
            <QuestionnaireModal questArr={questionnaire.questinnare7Sub2} popDisplay={showQest7Sub2} onModalClick={onModalClick} questName='questinnare7Sub2' />
        </>
    )
}

export default QuestionnaireCheckboxWrapper;